import { createProfessionalExporter } from '../../../utils/professionalExport';
import { formatGymPrice } from '../../../utils/gymMoney';
import { getGymMemberId } from '../members/memberData';

const headers = ['Date', 'Package', 'Payment (Debit)', 'Sale (Credit)', 'Balance'];

function moneyCell(amount) {
  const value = Number(amount) || 0;
  return value ? formatGymPrice(value) : '—';
}

function packageLabel(row) {
  const pkg = String(row?.package || '').trim() || '—';
  const type = String(row?.type || '').trim();
  if (type && type !== pkg) return `${pkg} (${type})`;
  return pkg;
}

const exporter = createProfessionalExporter({
  title: 'Customer Ledger',
  headers,
  slug: 'customer-ledger',
  getRows: ({ entries = [] } = {}) =>
    entries.map((row) => [
      row.date || '—',
      packageLabel(row),
      moneyCell(row.debit),
      moneyCell(row.credit),
      formatGymPrice(row.balance),
    ]),
  getSummary: ({ member, entries = [] } = {}) => {
    const debit = entries.reduce((sum, row) => sum + (Number(row.debit) || 0), 0);
    const credit = entries.reduce((sum, row) => sum + (Number(row.credit) || 0), 0);
    const closing = entries.length ? entries[entries.length - 1].balance : 0;
    return [
      `Serial: ${getGymMemberId(member) || '—'}`,
      `Name: ${member?.name || '—'}`,
      `Phone: ${member?.phone || member?.mobile || '—'}`,
      `Email: ${member?.email || '—'}`,
      `Branch: ${member?.branch || '—'}`,
      `Package: ${member?.package || '—'}`,
      `Status: ${member?.status || '—'}`,
      `Entries: ${entries.length}`,
      `Total payment (debit): ${formatGymPrice(debit)}`,
      `Total sale (credit): ${formatGymPrice(credit)}`,
      `Closing balance: ${formatGymPrice(closing)}`,
    ];
  },
});

export const printCustomerLedger = (data) => exporter.print(data);
export const exportCustomerLedgerCsv = (data) => exporter.csv(data);
export const exportCustomerLedgerExcel = (data) => exporter.excel(data);
export const exportCustomerLedgerPdf = (data) => exporter.pdf(data);
export const exportCustomerLedger = (data) => exporter.export(data);
